import logo from '../images/logo.png'
import { NavLink } from 'react-router-dom'

const Navbar = () => {
    return (
        <nav className='flex px-5 items-center justify-between  max-[768px]:justify-center h-16 text-[#1D58E2] w-full font-inter font-medium'>
            <img src={logo} alt="logo" className='h-12' />
            <div className='flex gap-3 max-[768px]:hidden'>
                <p className='p-2 cursor-pointer truncate hover:opacity-85'>Home</p>
                <p className='p-2 cursor-pointer truncate hover:opacity-85'>About Us</p>
                <p className='p-2 cursor-pointer truncate hover:opacity-85'>Blog</p>
                <NavLink
                    className=''
                    to="/"
                    style={({ isActive }) => {
                        return {
                            backgroundColor: isActive ? '#1D58E2' : 'white',
                            color: isActive ? "white" : "#1D58E2",
                        };
                    }}
                ><p className='px-6 py-2 cursor-pointer hover:bg-[#D2232A] hover:text-white'>Products</p></NavLink>
            </div>
        </nav>
    )
}

export default Navbar